import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStackAdapt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0061ff",
		d: "m49.05 28.726-8.986-10.718L44.73 8H27.666a16.59 16.59 0 0 0-15.039 9.586 16.59 16.59 0 0 0 2.324 17.688l8.985 10.723L19.271 56h17.063c6.452 0 12.312-3.74 15.039-9.586a16.59 16.59 0 0 0-2.324-17.688m-2.717 15.332a3.22 3.22 0 0 1-2.918 1.862H27.05l3.567-7.646L18.123 23.38a3.22 3.22 0 0 1 2.467-5.295h16.36l-3.563 7.65 12.494 14.886c.802.96.98 2.299.452 3.432z"
	})
});
export default SvgStackAdapt;
